import { getApiInstance } from '../api';

export const listIntegrators = async ({
  token,
  page,
}: {
  token: string;
  page: number;
}) => {
  const api = getApiInstance(token);
  try {
    const searchParams = new URLSearchParams({
      page: String(page),
    });

    const { data } = await api.get(`/integrators?${searchParams.toString()}`);

    return { success: true, data: data.data, count: data.count };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: `Erro ao carregar integradores. ${(error as Error).message}`,
    };
  }
};
